import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-brandings-scales-list',
  templateUrl: './brandings-scales-list.component.html',
  styleUrls: ['./brandings-scales-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BrandingsScalesListComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() brandingTypeName: string;
  @Input() brandingTypeId: number;
  @Input() enableEdit: boolean;
  @Output() addScale = new EventEmitter();
  @Output() save: EventEmitter<number> = new EventEmitter();
  @Output() saveAllScales: EventEmitter<boolean> = new EventEmitter();
  @Output() delete: EventEmitter<number> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  get scalesFormArray(): FormArray {
    if (this.form) {
      return this.form.controls.scales as FormArray;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/branding/brandings-scales-list/brandings-scales-list.component.ts